module.exports = __webpack_public_path__ + "static/media/hallstahammarvapen.dcb0a31d.png";